// MS-L4B — Pre-WhatsApp Disclosure (frontend only).
// Shared Dialog invoked from both landing CTAs (hero + final band) before
// opening WhatsApp. No backend, onboarding, URL or precompiled message is
// modified: `Continua` opens the SAME `REACT_APP_MASTRO_WHATSAPP_URL` in a
// new tab, synchronously, to avoid popup blockers.
import { Handshake } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

const WHATSAPP_URL = process.env.REACT_APP_MASTRO_WHATSAPP_URL;

export const WhatsAppDisclosureDialog = ({ open, onOpenChange }) => {
  const handleContinue = () => {
    // Synchronous open: keep this call inside the user-gesture click handler
    // (no `await` above) so browsers don't treat it as a popup.
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="whatsapp-disclosure-dialog"
        className="max-w-md gap-5 rounded-2xl border border-neutral-200 bg-white p-6 sm:p-7"
      >
        <DialogHeader className="flex flex-col items-start gap-3 text-left sm:text-left">
          <span
            aria-hidden="true"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-50"
            data-testid="whatsapp-disclosure-icon"
          >
            <Handshake className="h-6 w-6 text-amber-500" />
          </span>
          <DialogTitle
            data-testid="whatsapp-disclosure-title"
            className="text-xl font-bold tracking-tight text-neutral-950"
          >
            Prima di iniziare
          </DialogTitle>
        </DialogHeader>

        <DialogDescription asChild>
          <div
            data-testid="whatsapp-disclosure-body"
            className="space-y-3 text-sm leading-relaxed text-neutral-700"
          >
            <p>
              Mastro usa l’intelligenza artificiale per comprendere i tuoi
              messaggi e aiutarti a tenere tutto in ordine.
            </p>
            <p>
              Le tue informazioni vengono usate solo per offrirti il servizio e
              sono trattate con riservatezza, tramite i soli fornitori tecnici
              necessari al funzionamento.
            </p>
          </div>
        </DialogDescription>

        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
          <Link
            to="/privacy"
            data-testid="whatsapp-disclosure-link-privacy"
            onClick={() => onOpenChange(false)}
            className="font-medium text-teal-700 underline-offset-4 hover:underline"
          >
            Privacy Policy
          </Link>
          <Link
            to="/termini"
            data-testid="whatsapp-disclosure-link-terms"
            onClick={() => onOpenChange(false)}
            className="font-medium text-teal-700 underline-offset-4 hover:underline"
          >
            Termini
          </Link>
        </div>

        <DialogFooter className="mt-1">
          <button
            type="button"
            data-testid="whatsapp-disclosure-continue"
            onClick={handleContinue}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-teal-500 px-5 py-3 text-base font-bold text-neutral-950 transition-colors hover:bg-teal-400 sm:w-auto"
          >
            Continua
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
